
<div class="modal active obstacleDataImport">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Obstacle Data Import Options</h2>
      <div class="close" (click)="cancelObstacleDataImport()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngObstacleDataImport" #ngForm="ngForm" id="ObstacleDataImport" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Separators Configuration</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Field Separator</label>
                  <select name="fieldSeparator"
                  [(ngModel)]="obstacleImportCSVModel.fieldSeparator">
                    <option value=".">Dot (.)</option>
                    <option value=",">Comma (,)</option>
                    <option value=";">Semicolon (;)</option>
                    <option value="\t">Tab</option>
                    <option value=" ">Space</option>
                  </select>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Decimal Separator</label>
                  <select name="decimalSeparator"
                  [(ngModel)]="obstacleImportCSVModel.decimalSeparator">
                    <option value=".">Dot (.)</option>
                    <option value=",">Comma (,)</option>
                    <option value=";">Semicolon (;)</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>CSV file Source</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File Name</label>
                  <input
                  style="padding-left: 0px;"
                  maxlength="300"
                  type="file"
                  name="filename"
                  id="filename"
                  #uploadCsvFile
                  (change)="saveFile($event)"
                  [accept]="importFormat.fileExtension"
                  />
                </div>
            </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startImport();" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelObstacleDataImport()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
